import React from 'react'
import PropTypes from 'prop-types'
import ErrorBoundary from '../bugsnagHelper'
import DevelopmentErrorBoundary from '../DevelopmentErrorBoundary/DevelopmentErrorBoundary'
import ErrorView from 'pages/ErrorView/ErrorView'

const ConditionalErrorBoundary = ({ children, user, ...props }) => {
    if (process.env.NODE_ENV === 'development') {
        return (
            <DevelopmentErrorBoundary user={user}>
                {children}
            </DevelopmentErrorBoundary>
        )
    }

    return (
        <ErrorBoundary FallbackComponent={ErrorView} {...props}>
            {children}
        </ErrorBoundary>
    )
}

ConditionalErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    user: PropTypes.object
}

export default ConditionalErrorBoundary 